export default __webpack_public_path__ + "static/media/show-pruner-1.61b7b64a.webp";